import React, { useEffect, useState } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Menu,
  MenuItem,
  TextField,
  Select,
  FormControl,
  InputLabel,
  Box,
  Modal,
  IconButton,
  Typography,
  TablePagination,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Close } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
// Import local images
import image1 from "../../assets/images/image1.jpg";
import image2 from "../../assets/images/image2.jpg";
import image3 from "../../assets/images/image3.jpg";


import { BASE_URL_TEST } from "../../utils/baseUrl";
import { useFetch,useUpdate } from "../../hooks";
import { urls } from "../../urls/urls";

import { useSelector } from "react-redux";
import { ScriptHtml } from "../../utils";
import { SnackBarComponent } from "../../components";

const AdminListingProduct = () => {
  const loginToken = useSelector((state) => state.user.logintoken);

    const [snackbarState, setSnackbarState] = useState({
      open: false,
      severity: "success", // Default severity
      message: "",
      position: { vertical: "top", horizontal: "center" },
    });
const {data:productListingData,error:productListingError,isLoading:productListingLoading,fetchData:productListingFetchData}=useFetch(BASE_URL_TEST+ urls("getAllVListing"),{
      method:'GET',
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    })

      const {
        data: updatedStatusData,
        isLoading: updatedStatusLoading,
        error: updatedStatusError,
        updateData: fetchStatusUpdateData,
      } = useUpdate(BASE_URL_TEST, {
        method: "PUT",
        headers: {
          Authorization: loginToken ? `Bearer ${loginToken}` : "",
        },
      });


  const [brands, setBrands] = useState([
    {
      id: 3453,
      listingId: "L1001",
      vendorId: "V1001",
      category: "Electronics",
      subcategory: "Mobile",
      image: image1, // Local image
      title: "Mobile Phone",
      salesPrice: "500",
      status: "Active",
      description: "This is a mobile phone",
    },
    {
      id: 75667,
      listingId: "L1002",
      vendorId: "V1002",
      category: "Electronics",
      subcategory: "Laptop",
      image: image2, // Local image
      title: "Laptop",
      salesPrice: "1000",
      status: "Active",
      description: "This is a laptop",
    },
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [form, setForm] = useState({
    vlisting_id: "",
    vendor_id: "",
    category_name: "",
    category_id:"",
    subcategory: "",
    name: "",
    quantity: "",
    price: "",
    status: 0,
    description: "",
    images: "",
    vendor:"",
    self_delivery:"",
    self_pickup:""
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [previewImage, setPreviewImage] = useState(null); // State for image preview popup

  const [allProdListingData,setAllProdListingData]=useState([]);

  const handleSearch = (event) => setSearch(event.target.value);

  const handleMenuOpen = (event, brand) => {
    console.log("brand clicked",brand)
    setIsEditMode(true);
    setAnchorEl(event.currentTarget);
    setSelectedBrand(brand);
  };

  const handleMenuClose = () => setAnchorEl(null);

  const handleView = () => {
    setForm(selectedBrand);
    setModalOpen(true);
    handleMenuClose();
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setForm({
      listingId: "",
      vendorId: "",
      category: "",
      subcategory: "",
      title: "",
      salesPrice: "",
      status: "Active",
      description: "",
      image: "",
    });
    setIsEditMode(false);
    setPreviewImage(null); // Reset preview image on close
  };

  const handleInputChange = (e) => {
    setForm({ ...form, status: e.target.value=='Active' ?1 :0 });
  };

  const handleImageUpload = (e) => {
    setForm({ ...form, image: URL.createObjectURL(e.target.files[0]) });
    setPreviewImage(URL.createObjectURL(e.target.files[0])); // Set the preview image
  };

  // form.images = [image1, image2, image3]; // Add local images to form.images

  const handleSubmit = () => {
    console.log("formValues",form)
    if (form.status === 0 || form.status === 1)
    {
        const formdata = new FormData();
            const updateUrl = urls("updateStatusVListing", form['vlisting_id']);
            fetchStatusUpdateData(updateUrl, {
              "status": form["status"]
          });
    }
    handleModalClose();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredBrands = search
  ? allProdListingData.filter(
      (brand) =>
        brand.title.toLowerCase().includes(search.toLowerCase()) 
    )
  : allProdListingData;

  // const filteredBrands = allProdListingData.filter((brand) =>
  //   brand.title.toLowerCase().includes(search.toLowerCase())
  // );

  const handleImageClick = (imageUrl) => {
    setPreviewImage(imageUrl); // Set clicked image as preview in modal
  };


  useEffect(()=>{
    productListingFetchData()
  },[])


  useEffect(()=>{

    if(productListingError)
    {

    }
    else if(productListingData && productListingData['status']==true)
    {
      setAllProdListingData(productListingData['data'])   
    }

  },[productListingData,productListingError])


  useEffect(()=>{

    if(updatedStatusError)
    {

    }
    else if(updatedStatusData && updatedStatusData['status']==true)
    {
      
      
      setSnackbarState({
        ...snackbarState,
        open: true,
        message: updatedStatusData["message"],
        position: { vertical: "top", horizontal: "center" },
        severity: "success",
      });
      setModalOpen(false);
      productListingFetchData()
    }

  },[updatedStatusData,updatedStatusError])


  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ padding: 2, backgroundColor: "#F9FAFC" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
         <SnackBarComponent
                open={snackbarState.open}
                onClose={handleSnackbarClose}
                severity={snackbarState.severity}
                message={snackbarState.message}
                position={snackbarState.position}
              />
        <TextField
          variant="outlined"
          placeholder="Search"
          size="small"
          value={search}
          onChange={handleSearch}
          sx={{ width: "30%", backgroundColor: "#FFF", borderRadius: 1 }}
        />
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Listing ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Vendor ID</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Image</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Sales Price</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredBrands
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((brand) => (
                <TableRow key={brand.vlisting_id}>
                  <TableCell>{brand.vlisting_id}</TableCell>
                  <TableCell>{brand.vendor_id}</TableCell>
                  <TableCell>{brand.name}</TableCell>
                  <TableCell>
                    {brand.images && brand.images.length > 0 && brand.images[0]?.image_url ? (
                      <img
                        src={brand.images[0].image_url}
                        alt="logo"
                        width={40}
                        height={40}
                        onClick={() => handleImageClick(brand.images[0].image_url)} // Click to open image preview
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      "No Image"
                    )}
                  </TableCell>
                  <TableCell>
                    <Typography
                        color={brand.status === 1 ? "green" : "gray"}
                    >
                      {brand.status ==1 ?"Active":"InActive"}
                    </Typography>
                  </TableCell>
                  <TableCell>{brand.price}</TableCell>
                  <TableCell>
                    <MoreVertIcon onClick={(e) => handleMenuOpen(e, brand)} />
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleView}>View</MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredBrands.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      {/* Modal for Image Preview (Popup) */}
      <Modal open={previewImage !== null} onClose={() => setPreviewImage(null)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 700,
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
            p: 4,
            textAlign: "center",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setPreviewImage(null)}
          >
            <Close />
          </IconButton>
          <img
            src={previewImage}
            alt="Large Preview"
            style={{
              width: "100%",
              maxWidth: "600px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Modal>

      {/* Modal for Product Details */}
      <Modal open={modalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: 700,
            height: "auto",
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.25)",
            p: 4,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={handleModalClose}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" mb={2}>
            {isEditMode ? "View Product Details" : "Add Slider"}
          </Typography>
          <TextField
          disabled
            name="listingId"
            label="Listing ID"
            fullWidth
            margin="dense"
            value={form.vlisting_id}
            onChange={handleInputChange}
          />
          <TextField
          disabled
            name="vendorId"
            label="Vendor ID"
            fullWidth
            margin="dense"
            value={form.vendor_id}
            onChange={handleInputChange}
          />
          <TextField
          disabled
            name="category"
            label="Category"
            fullWidth
            margin="dense"
            value={form.category_name}
            onChange={handleInputChange}
          />

          <TextField
          disabled
            name="salesPrice"
            label="Sales Price"
            fullWidth
            margin="dense"
            value={form.price}
            onChange={handleInputChange}
          />
          <TextField
            disabled
            name="description"
            label="Description"
            fullWidth
            margin="dense"
            multiline
            
            rows={4}
            value={ScriptHtml(form.description)}
            onChange={handleInputChange}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={form.status==1 ? 'Active' :'Inactive'}
              onChange={handleInputChange}
              label="Status"
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ mt: 2 }}>
            {form.images &&
              form.images.length > 0 &&
              form.images.map((image, index) => (
                image?.image_url && (
                  <img
                    key={index}
                    src={image.image_url}
                    alt={`preview-${index}`}
                    width={100}
                    height={100}
                    style={{
                      borderRadius: "8px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                    onClick={() => setPreviewImage(image.image_url)} // Preview image click
                  />
                )
              ))}
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              variant="contained"
              color="success"
              sx={{ mt: 2 }}
              onClick={handleSubmit}>
              Update
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default AdminListingProduct;
